import { authentication } from '@/modules/authentication/store';

/**
 * Check if a user has a specific role granted by looking for a key inside the decoded JWT
 * @param role A value from the enum Roles
 * @see Roles
 * @returns true if the user has the role granted, false otherwise
 */
export function checkRole(role: string): boolean {
  // eslint-disable-next-line
  const token = authentication.state.decodedJwtToken as any;

  return token.resource_access?.demlab?.roles?.includes(role);
}
